/* !
 * jQuery findimage_sp v1.0.0
 * Copyright 2021, Connecty Inc.
 * use: Vue.js v1.0.28
 */
(function ($, SANGETSU){
	const v = 'is-visible';
	const n = 'is-novisible';
	const l = 'is-loading';
	let timer = false;
	let map = SANGETSU.va.pathname.split('/')[4];
	let map2
	let thisId;
	if (map === 'detail') {
		thisId = SANGETSU.va.pathname.split('/')[5].replace(/\.html/g, ''); // URLからID取得
	} else if (map === 'catalog') {
		map2 = SANGETSU.va.pathname.split('/')[5].replace(/\.html/g, '').replace(/index/g, '');
	}

	// CSV取得
	const csvToArray = (strData) => {
		const strDelimiter = ',';
		const objPattern = new RegExp(
			(
				'(\\' + strDelimiter + '|\\r?\\n|\\r|^)' +
				'(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|' +
				'([^\"\\' + strDelimiter + '\\r\\n]*))'
			),
			'gi'
		);
		let arrData = [[]];
		let arrMatches = null;
		let strMatchedValue;
		while((arrMatches = objPattern.exec(strData)) !== null) {
			let strMatchedDelimiter = arrMatches[1];
			if (strMatchedDelimiter.length && (strMatchedDelimiter !== strDelimiter)) {
				arrData.push([]);
			}
			if (arrMatches[2]) {
				strMatchedValue = arrMatches[2].replace(new RegExp('\"\"', 'g'), '\"');
			} else {
				strMatchedValue = arrMatches[3];
			}
			arrData[arrData.length - 1].push(strMatchedValue);
		}
		// console.dir(arrData);

		let items = arrData[0];
		let jsonArr = [];
		for(let i = 1; i < arrData.length - 1; i++) {
			if (arrData[i].length) {
				let a_line = {};
				let csvArrayD = arrData[i];
				for(let j = 0; j < items.length; j++) {
					a_line[items[j]] = csvArrayD[j];
				}
				jsonArr.push(a_line);
			}
		}
		return(jsonArr);
	};

	// ＜一覧＞画像事前読み込み
	const promiseThumbnailImageLoad = () => {
		const d = $.Deferred();
		const $img = $('.findimages-list').find('img');
		const imgLen = $img.length;
		let array = [];

		const sum = (_$this) => {
			array.push(_$this);
			if (imgLen === array.length) {
				d.resolve();
			}
		};
		const loaded = (_$this) => {
			if (_$this.complete) {
				sum(_$this);
			} else {
				let img = new Image();
				img.src = _$this[0].src;
				img.addEventListener('load', () => sum(_$this));
			}
		};

		if (imgLen === 0) {
			d.resolve();
		} else {
			for (let i = 0; i < imgLen; i++) {
				loaded($img.eq(i));
			}
		}

		return d.promise();
	};

	// ＜詳細＞画像事前読み込み
	const promiseDetailImageLoad = () => {
		const d = $.Deferred();
		const $img = $('.coordinate-detail-img').find('img');
		const imgLen = $img.length;
		let array = [];

		const sum = (_$this) => {
			array.push(_$this);
			if (imgLen === array.length) {
				d.resolve();
			}
		};
		const loaded = (_$this) => {
			let img = new Image();
			img.src = _$this[0].src;
			img.addEventListener('load', () => sum(_$this));
		};

		for (var i = 0; i < imgLen; i++) {
			loaded($img.eq(i));
		}

		return d.promise();
	};

	// 読み込み完了時の処理
	const endLoad = () => {
		if (SANGETSU.va.pathname.indexOf('detail') === -1) {
			$.when(
				promiseThumbnailImageLoad()
			).done(function (){
				$('.findimages-list-text .__head .__pn').matchHeight();
				$('.findimages-list-text .__head .__prodName').matchHeight();
				$('.mod-loader').removeClass(l);
				$('.findimages-main').addClass(v);
				$('.findimages-amount').addClass(v);
				$('img').bind('contextmenu', function (){
					return false;
				});
			});
		} else {
			// メイン画像
			$.when(
				promiseDetailImageLoad()
			).done(function (){
				$('.coordinate-detail-img').owlCarousel({
					items: 1,
					autoplay: false,
					loop: true,
					nav: true,
					navText: '',
					thumbs: true,
					thumbImage: true,
					thumbContainerClass: 'owl-thumbs',
					thumbItemClass: 'owl-thumb-item'
				});

				$('.mod-loader').removeClass(l);

				// 配列にあるIDのコーディネート画像は右クリック禁止
				const excID = [];
				if (excID.indexOf(thisId) >= 0) {
					$('img').bind('contextmenu', () => {
						return false;
					});
				}
				$('.findimages_detail').addClass(v);
			});

			// 使用商品画像読み込み
			$('.__itemList').each((idx, ele) => {
				if (!$(ele).find('li').length) {
					$(ele).remove();
				}
			});
		}
	};

	// -- ▲ functions ▲ -------------------------------------------------------------------
	// ------------------------------------------------------------------------------------

	let csvData = new XMLHttpRequest();
	csvData.open('get', '/newproduct/carpettile/coordinate/item.csv', true);
	csvData.send(null);
	csvData.onload = function (){
		let json = csvToArray(csvData.responseText);
		let vue = new Vue({
			el: '#vue-item',
			data: {
				jsonData: json,
				num: 0,
				page: 0,
				dispItemSize: 20,
				pn: '',
				checkedPrice: [],
			},
			created: function () {
				this.$watch('page', function () {
					$('.findimages-main').addClass(n);
					$('.mod-loader').addClass(l);
					$('.findimages-main').removeClass(v);
					this.$nextTick(function () {
						$('.findimages-main').removeClass(n);
						endLoad();
					});
				});
				this.$watch('checkedPrice', function () {
					this.page = 0;
					this.$nextTick(function () {
						$('.findimages-list-text .__head .__pn').matchHeight();
						$('.findimages-list-text .__head .__prodName').matchHeight();
					});
				});
			},
			methods: {
				// ＜一覧＞品番検索
				searchPn: function () {
					$('.findimages-main').addClass(n);
					$('.mod-loader').addClass(l);
					$('.findimages-main').removeClass(v);
					this.pn = $('#product_number').val().replace(/-/g, '');
					this.page = 0;
					this.$nextTick(function () {
						$('.findimages-main').removeClass(n);
						endLoad();
					});
				},
				detailID: function (item) {
					if (item.id === thisId) { return item; }
					return false;
				},
				showPrev: function () {
					if (this.isStartPage) return;
					$('.findimages-main').addClass(n);
					$('.mod-loader').addClass(l);
					$('.findimages-main').removeClass(v);
					$(window).scrollTop(0);
					this.page--;
					$('.findimages-main').removeClass(n);
				},
				showNext: function () {
					if (this.isEndPage) return;
					$('.findimages-main').addClass(n);
					$('.mod-loader').addClass(l);
					$('.findimages-main').removeClass(v);
					$(window).scrollTop(0);
					this.page++;
					$('.findimages-main').removeClass(n);
				},
				showPage: function (index) {
					$('.findimages-main').addClass(n);
					$('.mod-loader').addClass(l);
					$('.findimages-main').removeClass(v);
					$(window).scrollTop(0);
					this.page = index;
					$('.findimages-main').removeClass(n);
				},
				isOT: function (_otFlg) {
					return (_otFlg === 'ot');
				},
				setURL: function (_id) {
					return '/newproduct/carpettile/coordinate/detail/'+ _id + '.html';
				},
				setPDFURL: function (_id) {
					return '/pdf/newproduct/carpettile/coordinate/' + _id + '.pdf';
				},
				setImg: function (_id) {
					return'/images/newproduct/carpettile/coordinate/example/'+ _id + '.jpg';
				},
				setImgTile: function (_id) {
					return '/images/newproduct/carpettile/coordinate/tile/' + _id + '_tile.jpg';
				},
				setThumb: function (_id) {
					return'/images/newproduct/carpettile/coordinate/example/'+ _id + '_s.jpg';
				},
				setThumbTile: function (_id) {
					return '/images/newproduct/carpettile/coordinate/tile/' + _id + '_tile_s.jpg';
				},
				setImgDetail: function (_id) {
					let imgListHTML = `<div class="coordinate-detail-img-item"><img src='/images/newproduct/carpettile/coordinate/example/${_id}.jpg'></div>` +
						`<div class="coordinate-detail-img-item"><img src='/images/newproduct/carpettile/coordinate/tile/${_id}_tile.jpg'></div>`;
					return (imgListHTML);
				},
				setPn: function(_pn) { // pn, prodName
					let pnList = _pn.split('\n');
					let pnListHTML = '';
					for (let i = 0; i < pnList.length; i++) {
						pnListHTML += `<span>${pnList[i]}</span>　`;
					}
					return (pnListHTML);
				},
				setTags: function (_tags) {
					let tagArr = _tags.split('\n');
					let tagHTML = '';
					for (let i = 0; i < tagArr.length; i++) {
						let tagLabel;
						switch (tagArr[i]) {
							case 'entrance': tagLabel = 'エントランス/ロビー'; break;
							case 'hallway': tagLabel = '廊下'; break;
							case 'evhall': tagLabel = 'エレベーターホール'; break;
							case 'common': tagLabel = '共用部'; break;
							case 'office': tagLabel = '執務スペース'; break;
							case 'meeting': tagLabel = '打ち合わせスペース'; break;
							case 'tenants': tagLabel = '専門店/テナント'; break;
							case 'nt700': tagLabel = 'NT700'; break;
							// case 'ntdoubleeco': tagLabel = 'NT double eco'; break;
							case 'nt350': tagLabel = 'NT350'; break;
							case 'dt': tagLabel = 'DT'; break;
							default: break;
						}
						tagHTML += `<span>${tagLabel}</span>`;
					}
					return (tagHTML);
				},

				// ＜詳細＞ 使用商品
				setProd: function (_prod, _target) {
					if (!_prod.length) {
						return '';
					} else {
						let prodList = _prod.split('\n');
						let appendHTML = '';

						// 見出し作成
						let catLabel;
						switch (_target) {
							case 'carpettile': catLabel = 'カーペットタイル'; break;
							case 'vinyl': catLabel = '置敷きビニル床タイル'; break;
							default: break;
						};

						appendHTML += `<div class="__head"><span class="findimages-detail-category color-bg_${_target}">${catLabel}</span></div><div class="__body"><ul>`;

						$.each(prodList, (key, val) => {
							if (val) {
								let thisPN = val.split('/')[0];
								let thisName = val.split('/')[1];
								let thisPrice = val.split('/')[2];
								appendHTML += `<li class="__item ${_target}"><a href="/product/detail/${thisPN.replace(/-/, '')}/">`;

								// チップ画像
								appendHTML += `<figure><img src="/images/newproduct/carpettile/coordinate/chip/${thisPN.replace(/-/, '')}_C01.jpg">` +
									`<figcaption><span class="__pn">${thisPN}</span>`;

								if (thisName) { appendHTML += `<br><span class="__remarks">(${thisName})</span>`; }
								if (thisPrice) {
									appendHTML += `<br><span class="__price">${thisPrice.replace(/(\d)(?=(\d\d\d)+$)/g, '$1,')}円/㎡</span>`;
								}
								appendHTML += '</figcaption></figure></a></li>';
							}
						});

						appendHTML += '</ul></div>';

						return (appendHTML);
					}
				}
			},
			computed: {
				filterItems: function () {
					let items = this.jsonData;
					let itemsTemp = [];

					// OTタイルかどうか
					itemsTemp = [];
					if (map === 'ottile.html') {
						for (let i = 0; i < items.length; i++) {
							if (items[i].ot === 'ot') {
								itemsTemp.push(items[i]);
							}
						}
						items = itemsTemp;
					}

					let thisCat;
					itemsTemp = [];
					// URLから各カテゴリ絞り込み
					if (map !== 'detail' && map !== 'index.html' && map !== 'number' && map !== '' && map !== 'ottile.html') {
						thisCat = SANGETSU.va.pathname.split('/')[5].replace(/\.html/g, '');

						if (map === 'space') { // 空間で探す
							for (let i = 0; i < items.length; i++) {
								if (items[i].space.indexOf(thisCat) !== -1) {
									itemsTemp.push(items[i]);
								}
							}
							items = itemsTemp;

						} else if (map === 'catalog') { // カタログで探す
							if (map2) {
								for (let i = 0; i < items.length; i++) {
									if (items[i].catalog.indexOf(map2) !== -1) {
										// 価格絞り込み
										if (this.checkedPrice.length) {
											for (let j = 0; j < this.checkedPrice.length; j++) {
												if (items[i].price.indexOf(this.checkedPrice[j]) !== -1) {
													itemsTemp.push(items[i]); break;
												}
											}
										} else {
											itemsTemp.push(items[i]);
										}
									}
								}
							} else {
								// 価格絞り込み
								for (let i = 0; i < items.length; i++) {
									if (this.checkedPrice.length) {
										for (let j = 0; j < this.checkedPrice.length; j++) {
											if (items[i].price.indexOf(this.checkedPrice[j]) !== -1) {
												itemsTemp.push(items[i]); break;
											}
										}
									} else {
										itemsTemp.push(items[i]);
									}
								}
							}
							items = itemsTemp;
						}
					}

					// 品番・商品名検索（全使用商品）
					itemsTemp = [];
					if (map === 'number' && this.pn.length) {
						for (let i = 0; i < items.length; i++) {
							if (items[i].prod_carpettile.indexOf(this.pn) !== -1 || items[i].prod_vinyl.indexOf(this.pn) !== -1 ||
								items[i].pn.indexOf(this.pn) !== -1 || items[i].pn.replace(/-/g, '').indexOf(this.pn) !== -1) {
								itemsTemp.push(items[i]);
							}
						}
						items = itemsTemp;
					} else if (map === 'number') {
						// 初期表示（全て）
						for (let i = 0; i < items.length; i++) {
							itemsTemp.push(items[i]);
						}
						items = itemsTemp;
					}

					// count
					this.num = items.length;
					// paging
					let startPage = this.page * this.dispItemSize;
					items = items.slice(startPage, startPage + this.dispItemSize);

					// console.log(this.checkedPrice);

					return(items);
				},
				filterDetailItem: function () {
					let items = [];
					for(let i = 0; i < this.jsonData.length; i++) {
						if (thisId === this.jsonData[i].id) {
							items.push(this.jsonData[i]); break;
						}
					}
					if (items.length) {
						return(items);
					} else {
						// 存在しないIDでアクセスされた場合は404へリダイレクト
						location.href = '/404.html';
						return false;
					}
				},
				isStartPage: function () {
					return (this.page === 0);
				},
				isEndPage: function () {
					return ((this.page + 1) * this.dispItemSize >= this.num);
				},
				pageCount: function () {
					return Math.ceil(this.num / this.dispItemSize);
				}
			}
		});

		// 初回読み込み
		vue.$nextTick(function () {
			$('.findimages-main').removeClass(n);
			endLoad();
		});

		// 一覧の場合、matchHeight
		if (SANGETSU.va.pathname.indexOf('detail') === -1) {
			$(window).resize(function () {
				if (timer !== false) {
					clearTimeout(timer);
				}
				timer = setTimeout(function () {
					$('.js-mh').matchHeight();
				}, '200');
			});
		}

		// スムーススクロール
		$('a[rel="coordinateScroll"]').on('click', (event) => {
			let scrollSpeed = 1200;
			if (/#/.test(event.currentTarget.href)) {
				scrollToObject(event.currentTarget.href, scrollSpeed);
			}
			return false;
		});
		function scrollToObject(_self, _speed) {
			var hash = '#' + _self.split('#')[1];
			let pos = $(hash).offset().top;
			if (SANGETSU.va.window.width < SANGETSU.va.device.sp) {
				pos -= 60;
			} else {
				pos -= 141;
			}
			$('html,body').stop().animate({ scrollTop: pos }, _speed, 'easeOutExpo');
		}
	};

	// タブカレント表示
	$('.__tabList').find('a').each((idx, ele) => {
		if ($(ele).attr('href').split('/')[4] === map) {
			$(ele).addClass('is-active');

			// モバイル時 タブ部分のスクロール位置調整
			if (SANGETSU.va.window.width <= SANGETSU.va.device.sp) {
				$('.coordinate-head .__inner').scrollLeft($(ele).offset().left - 10);
			}
		}
	});
	// 下層絞り込みボタンカレント表示
	$('.button-list').find('a').each((idx, ele) => {
		if (location.pathname === $(ele).attr('href')) {
			$(ele).addClass('is-active');
		}
	});

})(window.jQuery, window.SANGETSU);
